<template>
    <div id="kobraSearchbar">
        <div class="flex text-center margin-bottom-20">
            <div class="width100 padding-horizontal-30 padding-horizontal-s-0">
                <button
                    id="kobraSearchSubmit"
                    type="button"
                    data-content=""
                    class="fa formSearchbar__submit"
                    @click="updateKobraSearch">
                    <i class="fa-search fa"></i>
                </button>
                <input
                    id="kobraQuery"
                    v-model="searchQuery"
                    type="text"
                    name="q"
                    required="required"
                    maxlength="1024"
                    autofocus="autofocus"
                    autocomplete="off"
                    class="search-autocomplete"
                    @keyup.enter="updateKobraSearch">
            </div>
        </div>
    </div>
</template>
<script>
    import Translator from 'tools/trans';
    import qs from 'qs';
    import { useGetters } from 'composables/useVuex';
    export default {
        name: 'KobraSearchbar',
        data: function() {
            return {
                selectedKobraBranchGroup: null,
                selectedKobraInfoType: null,
                selectedKobraSearchType: null,
                searchQuery: this.query,
            };
        },
        watch: {
            selectedKobraBranchGroup() {
                this.updateKobraUriFromParameters();
            },
            selectedKobraInfoType() {
                this.updateKobraUriFromParameters();
            },
            selectedKobraSearchType() {
                this.updateKobraUriFromParameters();
            },
        },
        methods: {
            trans: Translator.trans,
            updateKobraSearch() {
                this.$refs.kobrasearch.updateSearchResults();
                this.updateKobraUriFromParameters();
            },
            updateKobraUriFromParameters() {
                const parameters = qs.parse(window.location.search.substring(1));
                parameters.searchType = this.selectedKobraSearchType;
                parameters.branchGroup = this.selectedKobraBranchGroup;
                parameters.infoType = this.selectedKobraInfoType;
                parameters.q = this.searchQuery;

                history.pushState(null, null, `?${ qs.stringify(parameters) }#kobra`);
            },
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'query',
                    'getShowSidebar']),
            };
            const query = getters.query;

            return {
                query,
            };
        },
    };
</script>
